module.exports = __webpack_public_path__ + "img/Ko-T600.d849a5c3.gif";